import { dispatchServiceHasError } from '../../reducers/Rest/loadingStates';

export const isError = (dispatch, endpoint, hasError, errorMessage, data) =>
    dispatchServiceHasError(dispatch, endpoint, hasError, errorMessage, data);
